<template>
    <form ref='form' @submit.prevent="submit">
        <div class="">Esportazione</div>
        <div class="text-2xl font-bold">{{ titolo }}</div>
        <div class="grid grid-cols-2 gap-3 my-4">
            <div class="">
                <div class="font-bold py-2">Tipologia del file</div>
                <div class="py-2">
                    <Radio id="xlsx" value="xlsx" name="type" v-model="tipologia_file" checkClass="w-3 h-3">Excel
                    </Radio>
                </div>
                <div class="py-2">
                    <Radio id="pdf" value="pdf" name="type" v-model="tipologia_file" checkClass="w-3 h-3">PDF</Radio>
                </div>
                <div class="py-2">
                    <Radio id="both" value="both" name="type" v-model="tipologia_file" checkClass="w-3 h-3">Excel e
                        PDF
                    </Radio>
                </div>
            </div>
            <div class="col-span-2">
                <div class="font-bold py-2">Template</div>
                <select v-model="template" class="p-2 my-2 w-full" name="template">
                    <option disabled value="">Seleziona un template</option>
                    <option value="0">Interno BU (Esporta in base ai campi predefiniti della BU di progetto)</option>
                    <option value="1">Cliente BU (Esporta in base ai campi predefiniti della BU di progetto)</option>
                    <option value="2">Entrambi BU</option>
                    <option value="3">Personalizzato cliente (Esporta solo le colonne di vendita che vedi a schermo)
                    </option>
                    <option value="4">Personalizzato (Esporta solo le colonne che vedi a schermo)</option>
                    <!--                    <option value="5">Interno (Esporta sia colonne di acquisto che vendita)</option>-->
                    <!--                    <option value="6">Cliente (Esporta solo le colonne di vendita)</option>-->
                    <!--                    <option value="7">Entrambi</option>-->
                </select>
            </div>
            <NextButton variant="outline-secondary"
                        @click="$emit('chiudi')"
                        class="py-2 px-4 w-full">
                Chiudi
            </NextButton>
            <NextButton variant="primary"
                        :disabled="loading"
                        class="py-2 px-4 w-full flex items-center justify-center">
                <Spinner v-show="loading" class="w-4 h-4 mr-4"></Spinner>
                Esporta
            </NextButton>
            <p class="text-next-bri col-span-2" v-show="showSuccess">
                Il file è in generazione,<br>attendi il completamento e scaricalo nella
                <RouterLink :to="{name: 'DownloadCenter'}" target="_blank" class="underline">sezione download.
                </RouterLink>
            </p>
            <p class="text-center text-next-orange col-span-2" v-show="error">{{ error }}</p>
        </div>
    </form>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";
import Checkbox from "@/components/Checkbox.vue";
import Radio from "@/components/Radio.vue";
import Spinner from "@/components/Spinner.vue";
import axios, {ResponseType} from 'axios';
import env from "@/Environment";
import sottoProgettiManager from "@/api/SottoProgetti";

@Options({
    name: 'EsportaSottoprogetto',
    components: {
        Spinner,
        Radio,
        Checkbox,
        NextButton,
    },
    props: {
        id: [Number, String],
        titolo: String,
    }
})
export default class EsportaSottoprogetto extends Vue {
    id!: string;
    e = env;
    tipologia_file = 'xlsx'
    uso = 'cliente'
    error = ''
    showSuccess = false
    template = 0
    loading = false

    submit(event: any) {
        this.loading = true;
        this.error = ''
        const formData = new FormData(event.target);
        // @ts-ignore
        let queryString = new URLSearchParams(formData)
        const params:any = {}
        for (const [key, value] of queryString.entries()) {
            params[key] = value
        }
        sottoProgettiManager.exportSottoprogetto(this.id, {params}).then((response) => {
            console.log("Task ID: ", response.data.task_id);

            this.showSuccess = true;
        }).catch((res) => {
            if (res.response.status == 404) {
                this.error = "Impossibile generare il file, il sottoprogetto non contiene dati"
                return
            }
            this.error = "Impossibile generare il file"
        }).finally(() => {
            this.loading = false
        })
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
